module.exports = __webpack_public_path__ + "img/icon-tg.c00d6522.svg";